export default __webpack_public_path__ + "static/media/1723.7ddc6513.png";